(function () {
  'use strict';

  var hamburger  = document.getElementById('nav-hamburger');
  var nav        = document.getElementById('nav-primary');
  var overlay    = document.getElementById('nav-overlay');
  var closeBtn   = document.getElementById('nav-close-btn');
  var inner      = nav ? nav.querySelector('.nav-primary__inner') : null;
  var body       = document.body;
  var DESKTOP    = 1025;
  var DURATION   = 280; /* ms — must match CSS transition */

  if (!hamburger || !nav || !inner) return;

  /* ══════════════════════════════════════════════════
     DRAWER OPEN / CLOSE
     ══════════════════════════════════════════════════ */

  function openNav() {
    var scrollY = window.scrollY || window.pageYOffset;
    body.style.top = '-' + scrollY + 'px';
    nav.classList.add('nav-primary--open');
    body.classList.add('nav-open');
    hamburger.setAttribute('aria-expanded', 'true');
    if (overlay) { overlay.classList.add('nav-overlay--active'); overlay.removeAttribute('aria-hidden'); }
  }

  function closeNav() {
    var scrollY = parseInt(body.style.top || '0', 10) * -1;
    nav.classList.remove('nav-primary--open');
    body.classList.remove('nav-open');
    body.style.top = '';
    window.scrollTo(0, scrollY);
    hamburger.setAttribute('aria-expanded', 'false');
    if (overlay) { overlay.classList.remove('nav-overlay--active'); overlay.setAttribute('aria-hidden', 'true'); }
    resetPanels();
    nav.querySelectorAll('.mega-menu.open').forEach(function (item) { item.classList.remove('open'); });
  }

  hamburger.addEventListener('click', function () {
    nav.classList.contains('nav-primary--open') ? closeNav() : openNav();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('nav-primary--open')) {
      closeNav();
      hamburger.focus();
    }
  });

  /* ══════════════════════════════════════════════════
     MOBILE FLY-OUT PANELS
     Stack-based: each drill-in pushes state, back pops it.
     When activating a panel, JS moves it to be a direct
     child of #nav-primary so it positions relative to the
     nav viewport (not its original nested parent li).
     ══════════════════════════════════════════════════ */

  var panelStack = [];

  function drillIn(submenu) {
    if (window.innerWidth >= DESKTOP) return;

    /* Record original DOM position for restoration on back */
    var entry = {
      submenu:          submenu,
      originalParent:   submenu.parentNode,
      originalNext:     submenu.nextElementSibling
    };

    /* Move submenu to nav root so it positions relative to nav */
    nav.appendChild(submenu);

    /* Prime position off-right before showing */
    submenu.style.cssText = [
      'position:absolute',
      'top:0', 'left:0',
      'width:100%', 'height:100%',
      'z-index:2',
      'display:flex',
      'flex-direction:column',
      'overflow-y:auto',
      'background:#fff',
      'opacity:1',           /* override .js .mega-menu__content{opacity:0} */
      'transform:translateX(100%)',
      'transition:transform ' + DURATION + 'ms ease'
    ].join(';');

    /* Slide inner left, submenu in from right */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        inner.style.transition = 'transform ' + DURATION + 'ms ease';
        inner.style.transform = 'translateX(-100%)';
        submenu.style.transform = 'translateX(0)';
        submenu.classList.add('nav-primary__panel--active');
      });
    });

    panelStack.push(entry);
  }

  function drillOut() {
    if (panelStack.length === 0 || window.innerWidth >= DESKTOP) return;

    var entry   = panelStack[panelStack.length - 1];
    var submenu = entry.submenu;

    /* Slide submenu back right, inner back to centre */
    submenu.style.transform = 'translateX(100%)';
    inner.style.transform   = 'translateX(0)';

    setTimeout(function () {
      /* Restore to original DOM position */
      if (entry.originalNext) {
        entry.originalParent.insertBefore(submenu, entry.originalNext);
      } else {
        entry.originalParent.appendChild(submenu);
      }
      /* Remove all inline styles — CSS default takes over */
      submenu.removeAttribute('style');
      submenu.classList.remove('nav-primary__panel--active');
      panelStack.pop();

      if (panelStack.length === 0) {
        inner.style.transition = '';
        inner.style.transform  = '';
      }
    }, DURATION);
  }

  function resetPanels() {
    /* Restore any open panels to their original DOM positions */
    while (panelStack.length > 0) {
      var entry   = panelStack.pop();
      var submenu = entry.submenu;
      if (entry.originalNext) {
        entry.originalParent.insertBefore(submenu, entry.originalNext);
      } else {
        entry.originalParent.appendChild(submenu);
      }
      submenu.removeAttribute('style');
      submenu.classList.remove('nav-primary__panel--active');
    }
    inner.style.transition = '';
    inner.style.transform  = '';
  }

  /* ── Expand buttons: drill into submenus ── */
  nav.addEventListener('click', function (e) {
    var expandBtn = e.target.closest('.nav-primary__expand');
    if (!expandBtn || window.innerWidth >= DESKTOP) return;

    var parentRow = expandBtn.closest('.nav-primary__parent-row');
    if (!parentRow) return;

    var submenu = parentRow.nextElementSibling;
    if (!submenu || !submenu.classList.contains('nav-primary__submenu')) return;

    drillIn(submenu);
  });

  /* ── Back buttons: return to previous panel ── */
  nav.addEventListener('click', function (e) {
    if (e.target.closest('.nav-primary__back')) {
      drillOut();
    }
  });

  /* ══════════════════════════════════════════════════
     DESKTOP MEGA MENU
     mouseenter on .nav-primary__parent-row with 150ms
     open delay to filter header slide-in false triggers.
     ══════════════════════════════════════════════════ */

  function initMegaMenu() {
    if (window.innerWidth < DESKTOP) return;
    nav.querySelectorAll('.mega-menu').forEach(function (item) {
      if (item._megaMenuBound) return;
      item._megaMenuBound = true;

      var openTimer;
      var closeTimer;
      var trigger = item.querySelector('.nav-primary__parent-row') || item;

      trigger.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () {
          nav.querySelectorAll('.mega-menu.open').forEach(function (other) {
            if (other !== item) other.classList.remove('open');
          });
          item.classList.add('open');
        }, 150);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          item.classList.remove('open');
        }, 80);
      });
    });
  }

  initMegaMenu();

  /* ── Reset on resize ── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth >= DESKTOP) closeNav();
      initMegaMenu();
    }, 100);
  });

})();
